import React, {useState, useEffect } from 'react'
import attendanceServices from '../attendanceServices';
import MonthlyDateSelect from '../../../../../components/AppInput/MonthlyDateSelect';
import CalculateHours from '../../../../../components/CalculateHours';
import moment from 'moment';
import CalculateTotalWorkingHours from '../../../../../components/CalculateTotalWorkingHours';
import { useAppData } from '../../../../../context/AppDataContext';
import UpdatePunchForm from './UpdatePunchForm';

function EmployeeAttendanceList({employeeId}) {

    const {employeeDD,getDDDataById} = useAppData();
    const [filter,setFilter] = useState(null);
    const [attendanceList,setAttendanceList] = useState(null);

    const getAttendanceByEmployee = () =>{
        attendanceServices.getAttendanceByEmployee(employeeId,filter).then(res=>{
            setAttendanceList(res.data);
        }).catch(error=>{
            console.log(error);
        })
    }

    useEffect(()=>{
        getAttendanceByEmployee()
    },[filter])

    return (
        <div className='row'>
            <div className='col-md-12'>
                <h4 className='float-start' >{getDDDataById(employeeDD,employeeId).label} Attendance</h4>
                <span className='float-end'>
                    Date : <MonthlyDateSelect filter={filter} setFilter={setFilter} />
                </span>
            </div>
            <div className='col-md-12'>
                <table className='table table-striped'>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>In Time</th>
                            <th>Out Time</th>
                            <th>Hours</th>
                            <th><UpdatePunchForm employeeId={employeeId} callBack={getAttendanceByEmployee}  /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {attendanceList && attendanceList.map((punch)=>
                            <tr key={punch.id} className={punch.updatedBy !== null ? 'table-danger':""}>
                                <td>{moment(punch.inTime).format("D, MMM, dddd")}</td>
                                <td>{moment(punch.inTime).format("LLL")}</td>
                                <td>{punch.outTime !== null ?
                                        moment(punch.outTime).format("LLL")
                                        :
                                        "--------"
                                    }
                                </td>
                                <td> {punch.outTime !== null ?
                                        <CalculateHours inTime={punch.inTime} outTime={punch.outTime} />
                                        :
                                        <div>--------</div>
                                    }
                                </td>
                                <td>
                                    <UpdatePunchForm data={punch} callBack={getAttendanceByEmployee} />
                                </td>
                            </tr>
                        )}
                    </tbody>
                    {attendanceList &&
                        <tfoot>
                            <tr>
                                <td colSpan={5}>
                                    <CalculateTotalWorkingHours punchList={attendanceList} />
                                </td>
                            </tr>
                        </tfoot>
                    }
                </table>
                
            </div>

        </div>
    )
}

export default EmployeeAttendanceList